<template>
    <massive-file-loader
        :parser="parser"
        @loaded="$emit('loaded', $event)"
        @loading="$emit('loading')"
        @error="$emit('error')"
    />
</template>

<script>
import { parseFileMassiveLoadProductReferencesAndInventories } from "@/common/lib/excel";

import MassiveFileLoader from "@/components/utils/MassiveFileLoader.vue";

export default {
    name: "ProductsAndInventoriesFileLoader",
    components: { MassiveFileLoader },
    model: {
        prop: "filesCurrent",
        event: "loaded"
    },
    emits: ["loaded", "loading", "error"],
    data: () => ({
        parser: parseFileMassiveLoadProductReferencesAndInventories
    })
};
</script>
